import { Button } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import autobind from "autobind-decorator";
import { Component, Fragment } from "react";
import styled from "styled-components";

import IPropertyReference from "core/util/property/IPropertyReference";
import IPropertyType from "core/util/property/IPropertyType";
import NewPropertyDialog from "./NewPropertyDialog";
import PropertyForm from "./PropertyForm";
import PropertyList from "./PropertyList";

/**
 *
 *
 */

const Header = styled.div`
	display: flex;
	
	& > * {
		margin-right: 15px;
	}

	& > *:last-child {
		margin-right: 0;
	}
`;

export interface IPropertyEditorProps {
	openTarget: typeof PropertyEditor.TARGET_CHILD | typeof PropertyEditor.TARGET_SIDEBAR;
}

interface IPropertyEditorState {
	type: IPropertyType<any, any>;
	reference: IPropertyReference;
	header: JSX.Element;
}

export default class PropertyEditor extends Component<IPropertyEditorProps, IPropertyEditorState> {
	public static TARGET_CHILD = "child";
	public static TARGET_SIDEBAR = "sidebar";

	constructor(props: IPropertyEditorProps) {
		super(props);

		this.state = {type: null, reference: null, header: null};
	}

	@autobind
	public onClick(type: IPropertyType<any, any>, reference: IPropertyReference = null) {
		console.log("target: " + this.props.openTarget);
		console.log(type);
		console.log(reference);
		this.setState({type, reference});
	}

	@autobind
	private renderHeader(extra: React.ReactNode) {
		this.setState({header: (
			<Header>
				<NewPropertyDialog onClick={(type, reference) => {
					// set only the type and not the ref so editor goes into new mode
					this.onClick(type, reference);
				}}/>

				{extra}
			</Header>
		)});
	}

	public render() {
		const { type, reference, header } = this.state;

		if(/* PropertyEditor.TARGET_CHILD === this.props.openTarget &&  */(type || reference)) {
			return (
				<div style={{display: "grid", gridTemplateRows: "auto 1fr"}}>
					<Button icon={IconNames.CHEVRON_LEFT} onClick={() => this.setState({type: null, reference: null})}>Back</Button>
					<PropertyForm type={type} reference={reference}/>
				</div>
			);
		}

		return (
			<div style={{display: "grid", gridTemplateRows: "auto 1fr"}}>
				{header}

				<PropertyList renderHeader={this.renderHeader} headerUpdated={() => this.forceUpdate()} scope={"properties"} group={"default"} onClick={(type, reference) => {
					// set both the type and the ref so editor goes into edit mode
					this.onClick(type, reference);
				}}/>
			</div>
		);
	}
}

/*
function mapStateToProps(state: typeof initialState = initialState): IPropertyEditorProps {
	return {
		active: state.edit.active
	};
}

function mapDispatchToProps(dispatch: Dispatch<typeof initialState>): IPropertyEditorProps {
	return {
		actions: bindActionCreators(editActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PropertyEditor);*/



// WEBPACK FOOTER //
// ./src/core/components/editor/properties/PropertyEditor.tsx